export default __webpack_public_path__ + "static/media/voice_media_thumbnail.70eb758f.png";